import { atom } from 'recoil';

const uid = atom({
  key: 'uid',
  default: '',
});

export default uid;
